export default __webpack_public_path__ + "static/media/unlock-red.40b0edd9.svg";